<op-dynamic-form
    [resourcePath]="projectsPath"
    [formHttpMethod]="formMethod"
    [fieldsSettingsPipe]="dynamicFieldsSettingsPipe"
    helpTextAttributeScope="Project"
></op-dynamic-form>